module.exports = __webpack_public_path__ + "static/img/icon-calendar.f2fd14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-calendar.png
// module id = WfM0
// module chunks = 1 3 4 5 6 7